// Máscaras visuais em tempo real para inputs.
// Sem dependência externa — handlers leves que reformatam onChange.
// O valor "limpo" (só dígitos / alfanum) é o que vai pro RHF / Zod.

const onlyDigits = (s: string): string => s.replace(/\D/g, '');
const onlyAlphanumUpper = (s: string): string => s.toUpperCase().replace(/[^0-9A-Z]/g, '');

export function maskCpf(raw: string): string {
  const v = onlyDigits(raw).slice(0, 11);
  if (v.length <= 3) return v;
  if (v.length <= 6) return `${v.slice(0, 3)}.${v.slice(3)}`;
  if (v.length <= 9) return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6)}`;
  return `${v.slice(0, 3)}.${v.slice(3, 6)}.${v.slice(6, 9)}-${v.slice(9)}`;
}

/** CNPJ alfanumérico (DR-012): 12 alfanum + 2 dígitos DV. */
export function maskCnpj(raw: string): string {
  const v = onlyAlphanumUpper(raw).slice(0, 14);
  if (v.length <= 2) return v;
  if (v.length <= 5) return `${v.slice(0, 2)}.${v.slice(2)}`;
  if (v.length <= 8) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5)}`;
  if (v.length <= 12) return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8)}`;
  return `${v.slice(0, 2)}.${v.slice(2, 5)}.${v.slice(5, 8)}/${v.slice(8, 12)}-${v.slice(12)}`;
}

export function maskDocument(raw: string, type: 'CPF' | 'CNPJ'): string {
  return type === 'CPF' ? maskCpf(raw) : maskCnpj(raw);
}

/**
 * Auto-detecta CPF vs CNPJ durante a digitação em campo único "CPF ou CNPJ".
 * Letra em qualquer posição OU mais de 11 chars → CNPJ (alfanumérico DR-012).
 */
export function maskCpfCnpjAuto(raw: string): string {
  const v = onlyAlphanumUpper(raw);
  return /[A-Z]/.test(v) || v.length > 11 ? maskCnpj(raw) : maskCpf(raw);
}

export function maskCep(raw: string): string {
  const v = onlyDigits(raw).slice(0, 8);
  if (v.length <= 5) return v;
  return `${v.slice(0, 5)}-${v.slice(5)}`;
}

/** Telefone brasileiro: (XX) XXXX-XXXX ou (XX) 9XXXX-XXXX. */
export function maskPhone(raw: string): string {
  const v = onlyDigits(raw).slice(0, 11);
  if (v.length === 0) return '';
  if (v.length <= 2) return `(${v}`;
  if (v.length <= 6) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
  if (v.length <= 10) return `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`;
  return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`;
}

/** Remove máscara, devolvendo valor "limpo" pra mandar pro Zod. */
export function unmaskDigits(s: string): string {
  return onlyDigits(s);
}

export function unmaskDocument(s: string): string {
  return onlyAlphanumUpper(s);
}
